import * as React from 'react'
import useStyles from './AuthLayoutPage.styles'

interface IProps {
  children: React.ReactNode
}

export const AuthLayoutPage = ({ children }: IProps) => {
  const { classes } = useStyles()

  return (
    <div className={classes.wrapper}>
      <div className={classes.block}>{children}</div>
    </div>
  )
}
